<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon">close</mat-icon>
</button>
<h1 mat-dialog-title>Nuevo Formulario</h1>

<mat-dialog-content class="form-active">
  <mat-form-field>
    <input matInput required [disabled]="false" placeholder="Nombre" [(ngModel)]="name">
  </mat-form-field>
  <mat-form-field>
    <input matInput required [disabled]="false" placeholder="Descripción" [(ngModel)]="description">
  </mat-form-field>
  <mat-form-field>
    <mat-label>Capa</mat-label>
    <mat-select [(ngModel)]="layer" name='layer'>
      <mat-option *ngFor="let layer of layers" [value]="layer.capa_id">
        {{layer.capa_nombre}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)='createForm()'>Crear</button>
  <button mat-raised-button (click)='closeMe()' cdkFocusInitial>Cancelar</button>
</mat-dialog-actions>